export enum PREFIX {
  COLOR = '--color-',
  SPACING = '--spacing-',
}
